import searchCopy, { type SearchCopyKey } from '@/i18n/ns/search';
import type { WorkspaceIconName } from './icons';

export type FinderActionId = 'new-chat' | 'create-skill' | 'upload-files';

export interface FinderAction {
  id: FinderActionId;
  title: string;
  description: string;
  icon: WorkspaceIconName;
}

const actions: {
  id: FinderActionId;
  title: SearchCopyKey;
  description: SearchCopyKey;
  icon: WorkspaceIconName;
}[] = [
  { id: 'new-chat', title: 'newChat', description: 'newChatHint', icon: 'plus' },
  { id: 'create-skill', title: 'createSkill', description: 'createSkillHint', icon: 'skills' },
  { id: 'upload-files', title: 'upload', description: 'uploadHint', icon: 'upload' },
];

/** The actions whose visible title or description contains the query, in the
 * person's interface language (English when no copy is given). */
export function findWorkspaceActions(
  query: string,
  copy: Readonly<Record<SearchCopyKey, string>> = searchCopy.en,
  locale?: string,
): FinderAction[] {
  const needle = query.trim().toLocaleLowerCase(locale);
  return actions
    .map(({ id, title, description, icon }) => ({
      id,
      icon,
      title: copy[title],
      description: copy[description],
    }))
    .filter((action) =>
      `${action.title} ${action.description}`.toLocaleLowerCase(locale).includes(needle),
    );
}
